import type { DecimalDigits } from "./NumberFieldType"

const validateInputNumber = (
  value: string,
  options: {
    min: number
    max: number
    maxDecimalDigits: DecimalDigits
  }
) => {
  const { min, max, maxDecimalDigits } = options
  const maxIntegerDigits = Math.max(
    Math.trunc(Math.abs(min)).toString().length,
    Math.trunc(Math.abs(max)).toString().length
  )

  const errors = createErrorMessages(maxIntegerDigits, maxDecimalDigits)

  const numeric = /^-?\d*\.?\d*$/
  if (!numeric.test(value)) {
    return errors.numeric
  }

  const onlyPositive = min >= 0
  if (onlyPositive && value.includes("-")) {
    return errors.onlyPositive
  }

  const [integerPart, decimalPart] = value.split(".")

  if (integerPart !== undefined && integerPart.replace("-", "").length > maxIntegerDigits) {
    return errors.integerDigits
  }

  const onlyInteger = maxDecimalDigits === 0
  if (onlyInteger && value.includes(".")) {
    return errors.onlyInteger
  }

  if (decimalPart !== undefined && decimalPart.length > maxDecimalDigits) {
    return errors.decimalDigits
  }

  return null
}

export default validateInputNumber

const createErrorMessages = (maxIntegerDigits: number, maxDecimalDigits: DecimalDigits) => {
  return {
    numeric: "数値を入力してください。",
    onlyPositive: "正の数のみを入力してください。",
    integerDigits: `${maxIntegerDigits}桁以下の数値を入力してください。`,
    onlyInteger: "整数のみを入力してください。",
    decimalDigits: `小数第${maxDecimalDigits}位までを入力してください。`,
  }
}
